module.exports = __webpack_public_path__ + "static/media/largeLogo.15696a09.png";